<template>
    <date-picker
        v-model="innerValue"
        :type="type"
        :range="range"
        :placeholder="placeholder"
        :range-separator="rangeSeparator"
        :format="format"
        :value-type="valueType"
        :locale="locale"
        :popup-style="popupStyle"
        :shortcuts="shortcuts"
        :disabled-date="disabledDateHandler"
        v-bind="$attrs"
        v-on="$listeners"
        @change="handleChange"
    ></date-picker>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { datePickerLocale } from '@/utils/locale'

export default {
    name: 'BaseDatePicker',
    components: {
        DatePicker
    },
    props: {
        value: {
            type: [Date, Array, String],
            default: null
        },
        type: {
            type: String,
            default: 'date'
        },
        range: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: '选择日期'
        },
        rangeSeparator: {
            type: String,
            default: ' 至 '
        },
        format: {
            type: String,
            default: 'YYYY-MM-DD'
        },
        valueType: {
            type: String,
            default: 'YYYY-MM-DD'
        },
        popupStyle: {
            type: Object,
            default: () => ({ zIndex: 3000 })
        },
        shortcuts: {
            type: Array,
            default: () => []
        },
        disabledDate: {
            type: Function,
            default: null
        }
    },
    data() {
        return {
            locale: datePickerLocale,
            innerValue: this.value
        }
    },
    watch: {
        value(val) {
            this.innerValue = val
        }
    },
    methods: {
        handleChange(val) {
            this.$emit('input', val)
            this.$emit('change', val)
        },
        disabledDateHandler(date) {
            // 如果传入了 disabledDate 函数则使用它，否则返回 false（不禁用任何日期）
            return this.disabledDate ? this.disabledDate(date) : false
        }
    }
}
</script>

<style lang="scss">
.mx-datepicker-sidebar {
    .mx-btn-shortcut {
        color: #333;
        font-size: 12px;
        margin-bottom: 5px;
    }
}
.mx-range-wrapper {
    .mx-btn {
        color: #333;
    }
    .mx-calendar-content .cell.active {
        border-radius: 50%;
    }
}
.mx-datepicker-main {
    color: #333;
}
</style> 